import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronDown, ArrowLeft } from 'lucide-react';

const FAQS = [
  {
    q: 'What kind of perfumes does QASR Parfumerie offer?',
    a: 'We curate luxury Arabian fragrances from the most celebrated houses — including Reef, Gissah, IBRAQ, Paris Corner and Emir. From bold oud-led signatures to gourmand sweets and travel-friendly minis, our collection brings the heart of the Middle East to Australia.',
  },
  {
    q: 'Are your fragrances authentic?',
    a: 'Absolutely. Every bottle is sourced directly from the brand or authorised distributors. We never sell replicas, decants or grey-market stock.',
  },
  {
    q: 'How long do your fragrances last?',
    a: 'Most of our Eau de Parfums offer 6–10 hours of longevity. Concentrated parfums and oud-based scents can last 12+ hours on skin and considerably longer on fabric.',
  },
  {
    q: 'Can I sample a fragrance before buying a full bottle?',
    a: 'Yes — our Travel Mini collection (Reef 29, 33, and 42) lets you try our signature scents in a 35 AUD bottle before committing to a full size.',
  },
  {
    q: 'What is the QASR Club?',
    a: 'The Club is our private membership giving you early access to new releases, exclusive in-store previews, members-only fragrances and invitations to private events in Sydney. Join via "The Club" page.',
  },
  {
    q: 'Do you offer a discount for newsletter subscribers?',
    a: 'Yes. New subscribers automatically receive 10% off their first order — applied at checkout. No code required.',
  },
  {
    q: 'How do I know if a fragrance suits me?',
    a: 'Use our "Build Your Perfume" tool — select your favourite top, heart and base notes and we\'ll match you to the perfume in our collection that fits best. Or message us and we\'ll suggest something personally.',
  },
  {
    q: 'Are your perfumes vegan or cruelty-free?',
    a: 'Most of our houses follow vegan and cruelty-free standards. Specific certification varies by brand — please email us if a particular product\'s ingredients are critical to your decision.',
  },
  {
    q: 'How do I store my fragrance?',
    a: 'Keep your bottle away from direct sunlight, heat and humidity. A drawer or wardrobe is ideal. Properly stored, our fragrances retain their character for 3–5 years.',
  },
  {
    q: 'I have a question that\'s not answered here.',
    a: 'No problem — reach us via the Contact page. We respond to all enquiries within 24 hours.',
  },
];

const FAQPage = () => {
  const [openIdx, setOpenIdx] = useState(0);

  return (
    <div className="min-h-screen bg-[#050505] pt-28 pb-20" data-testid="faq-page">
      <div className="max-w-4xl mx-auto px-6 md:px-12">
        <Link to="/" data-testid="faq-back-link" className="inline-flex items-center gap-2 text-[#D4AF37] mb-8 hover:text-[#E5C158] transition-colors">
          <ArrowLeft size={18} />
          <span className="font-heading text-xs tracking-[0.2em]">BACK TO HOME</span>
        </Link>

        <div className="mb-12">
          <p className="font-arabic text-2xl text-[#D4AF37]/60 mb-2">الأسئلة الشائعة</p>
          <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl tracking-wide text-white mb-4">
            FREQUENTLY ASKED <span className="text-[#D4AF37]">QUESTIONS</span>
          </h1>
          <p className="font-body text-white/50 text-base">
            Everything you need to know about QASR Parfumerie.
          </p>
        </div>

        <div className="space-y-3">
          {FAQS.map((item, i) => {
            const open = openIdx === i;
            return (
              <div
                key={item.q}
                className={`border transition-colors duration-300 ${
                  open ? 'border-[#D4AF37]/40 bg-[#0a0a0a]' : 'border-[#D4AF37]/10 bg-[#0a0a0a]/40'
                }`}
                data-testid={`faq-item-${i}`}
              >
                <button
                  onClick={() => setOpenIdx(open ? -1 : i)}
                  className="w-full px-6 py-5 flex items-center justify-between gap-4 text-left"
                  data-testid={`faq-toggle-${i}`}
                >
                  <span className="font-heading text-sm md:text-base text-white tracking-wide pr-4">
                    {item.q}
                  </span>
                  <ChevronDown
                    size={20}
                    className={`flex-shrink-0 text-[#D4AF37] transition-transform duration-300 ${open ? 'rotate-180' : ''}`}
                  />
                </button>
                <div
                  className={`overflow-hidden transition-all duration-500 ease-in-out ${
                    open ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                  }`}
                >
                  <p className="px-6 pb-6 font-body text-white/60 text-sm leading-relaxed">
                    {item.a}
                  </p>
                </div>
              </div>
            );
          })}
        </div>

        <div className="mt-16 text-center border-t border-[#D4AF37]/15 pt-12">
          <p className="font-arabic text-xl text-[#D4AF37]/50 mb-2">للتواصل معنا</p>
          <p className="font-heading text-sm tracking-[0.2em] text-white/70 mb-6">STILL HAVE QUESTIONS?</p>
          <Link
            to="/contact"
            data-testid="faq-contact-cta"
            className="inline-block px-8 py-3 border border-[#D4AF37] text-[#D4AF37] font-heading text-xs tracking-[0.2em] hover:bg-[#D4AF37] hover:text-[#050505] transition-colors duration-200"
          >
            CONTACT US
          </Link>
        </div>
      </div>
    </div>
  );
};

export default FAQPage;
